module.exports = __webpack_public_path__ + "static/media/Search-1.ad0f3067.svg";